export default __webpack_public_path__ + "static/game-choice-scree-e250971154264388bb109838748a2c38.png";